export enum FlagValidator {
    Todos = 'T',
    Activos = 'A'
}

